import React from 'react';
import { useHelp } from './HelpDialog';
import Icon from './Icon';
import { QuickExitLink } from './QuickExit';

/** D6: on phones, Ayuda ahora + Salir rápido live at the bottom, in reach of the thumb. */
const BottomBar: React.FC = () => {
  const help = useHelp();
  return (
    <div className="bottom-bar" role="region" aria-label="Ayuda y salida rápida">
      <a
        className="btn btn--pink"
        href="/ayuda"
        onClick={(event) => {
          event.preventDefault();
          help.open();
        }}
      >
        <Icon name="heart" />
        Ayuda ahora
      </a>
      <QuickExitLink className="quick-exit" />
    </div>
  );
};

export default BottomBar;
